import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../http/api.service';
import { ApiResponse } from '../../shared/models/api.models';
import { MyVenueResponse, VenueResponse } from '../../shared/models/venue.models';
import { VenueMatchResponse } from '../../shared/models/match.models';
import { PromotionResponse } from '../../shared/models/promotion.models';
import { VenueStatsResponse, StatsPeriod } from '../../shared/models/stats.models';
import { NextMatchResponse } from '../../shared/models/next-match.models';

@Injectable({ providedIn: 'root' })
export class VenueService {
  private readonly api = inject(ApiService);

  getMyVenues(): Observable<ApiResponse<MyVenueResponse[]>> {
    return this.api.get<MyVenueResponse[]>('/panel/venues/me');
  }

  getVenue(publicId: string): Observable<ApiResponse<VenueResponse>> {
    return this.api.get<VenueResponse>(`/venues/${publicId}`);
  }

  getMatches(publicId: string): Observable<ApiResponse<VenueMatchResponse[]>> {
    return this.api.get<VenueMatchResponse[]>(`/venues/${publicId}/matches`);
  }

  getPromotions(publicId: string): Observable<ApiResponse<PromotionResponse[]>> {
    return this.api.get<PromotionResponse[]>(`/venues/${publicId}/promotions`);
  }

  getStats(publicId: string, period: StatsPeriod): Observable<ApiResponse<VenueStatsResponse>> {
    return this.api.get<VenueStatsResponse>(`/panel/venues/${publicId}/stats?period=${period}`);
  }

  getNextMatch(venuePublicId: string): Observable<ApiResponse<NextMatchResponse | null>> {
    return this.api.get<NextMatchResponse | null>(`/panel/venues/${venuePublicId}/next-match`);
  }
}
